import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapNamedDestinationSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapnameddestination: {
      group: 'inline',
      inline: true,
      attrs: {
        name: { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:namedDestination',
        getAttrs(dom) {
          return getSchemaAttrs(dom, ['name']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:namedDestination',
      isTagNameBox: true,
      isVoid: true
    }
  } satisfies Record<string, NodeSpec>;
}
